module.exports = __webpack_public_path__ + "public/img/Pelayanan Pelanggan untuk Customer Service .f0ce033a.png";